import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-journal",
  "use": "icon-journal-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-journal\"><path d=\"M92.672 147.456v604.672c0 29.696 22.016 60.928 49.664 71.168L495.104 947.2V236.032L142.336 111.616c-27.136-9.728-49.664 6.144-49.664 35.84z m789.504-36.864l-124.928 54.272v604.672c0 29.696-19.456 66.56-43.52 82.944l-96.256 65.024 264.704-95.744c27.648-9.216 49.664-40.96 49.664-70.144v-604.16c0-29.696-22.016-46.08-49.664-36.864zM721.92 751.616v-604.16c0-29.696-19.456-39.936-43.52-24.064l-148.48 112.64V947.2l148.48-112.64c24.064-16.384 43.52-53.248 43.52-82.944z\" p-id=\"1621\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/journal.svg
// module id = UVyV
// module chunks = 65